import { FC } from 'react';

import { SearchBar } from '../../../../app/modules/client-search/components/SearchBar';

const Header: FC = () => {
  return <SearchBar />;
};

export { Header };
